import createAngularModuleInstance from './createAngularModuleInstance.js';
import createClassInstance from './createClassInstance.js';

export class GHConstructor {
    constructor(gudhub) {
        this.gudhub = gudhub;
        this.cache = {};
        this.modulesQueue = {};
        this.angularInjector;
        this.nodeWindow;
    }

    /*************** GET INSTANCE ***************/
    // Firstly, check if module is loading right now in modules queue.
    // If not, check if module is in cache. If not, create new instance and put loading to modules queue.
    // If yes, return module from cache.

    async getInstance(module_id) {
        if(this.getCached(module_id)) {
            return this.getCached(module_id);
        } else if (this.modulesQueue[module_id]) {
            await this.modulesQueue[module_id];
        } else {
            this.modulesQueue[module_id] = this.createInstance(module_id);
            await this.modulesQueue[module_id];
        }
        return this.getCached(module_id);
    }

    /*************** PUT TO CACHE ***************/
    // Just pushing module to cache.

    pupToCache(module_id, module) {
        this.cache[module_id] = module;
    }

    /*************** GET CACHED ***************/
    // Find module in cache and return it.

    getCached(module_id) {
        return this.cache[module_id];
    }

    /*************** INIT ANGULAR INJECTOR ***************/
    // Saves angular injector to this.angularInjector.
    // It's needed to correctly takes module's functions, that uses angular services.

    initAngularInjector(angularInjector) {
        this.angularInjector = angularInjector;
    }

    /*************** INIT JSDOM WINDOW ***************/
    // Saves jsdom's window object to this.window.
    // It's needed to eval browser code on node when library works in node environment.

    initJsdomWindow(window) {
        this.nodeWindow = window;
    }

    /*************** CREATE INSTANCE ***************/
    // Check if module is "angular" or "class"
    // Than, creating instance for that type of module
    // Finally, returns the result (created instance) and puting it to the cache

    async createInstance(module_id) {
        let module = this.gudhub.storage.getModuleUrl(module_id);
        
        if(!module) {
            console.log(`Cannot find module: ${module_id}`);
            return;
        }

        let result;
        if (module.type === 'gh_element') {
            if(module.technology === 'angular') {
                result = await createAngularModuleInstance(this.gudhub, module_id, module.url, this.angularInjector, this.nodeWindow);
            } else if(module.technology === 'class') {
                result = await createClassInstance(this.gudhub, module_id, module.js, module.css, this.nodeWindow);
            }
        }

        if(result) {
            this.pupToCache(module_id, result);
        }
        
        return result;
    }
}
